import { webConstants } from '../_constants'

const initialState = {
  sidebarShow: true,
  asideShow: false,
  theme: 'default',
}

const webReducer = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case webConstants.SET:
      return { ...state, ...rest }
    default:
      return state
  }
}

export default webReducer
